module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer",
    class: {
      'footer-country': _vm.routeCountry
    }
  }, [_c('p', [_vm._v("Спецпроект")]), _vm._v(" "), _c('a', {
    staticClass: "header-heart",
    class: {
      'social-icon-color': !_vm.routeCountry && !_vm.GET_LOAD && _vm.$root.isMobile
    },
    attrs: {
      "href": "#"
    }
  }, [_c('Heart', {
    staticClass: "header-heart__svg"
  }), _vm._v(" "), _c('div', {
    staticClass: "header-social"
  }, [_c('share-link', {
    staticClass: "facebook-link",
    attrs: {
      "network": "fb",
      "url": "http://megafontravel.afisha.ru"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Share fb')
      }
    }
  }, [_c('FB', {
    staticClass: "icon-svg"
  })], 1), _vm._v(" "), _c('share-link', {
    staticClass: "ok-link",
    attrs: {
      "network": "ok",
      "url": "http://megafontravel.afisha.ru"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Share ok')
      }
    }
  }, [_c('OK', {
    staticClass: "icon-svg"
  })], 1), _vm._v(" "), _c('share-link', {
    staticClass: "vk-link",
    attrs: {
      "network": "vk",
      "url": "http://megafontravel.afisha.ru"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Share vk')
      }
    }
  }, [_c('VK', {
    staticClass: "icon-svg"
  })], 1), _vm._v(" "), _c('share-link', {
    staticClass: "twitter-link",
    attrs: {
      "network": "tw",
      "url": "http://megafontravel.afisha.ru"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Share tw')
      }
    }
  }, [_c('TW', {
    staticClass: "icon-svg"
  })], 1), _vm._v(" "), _c('share-link', {
    staticClass: "telegram-link",
    attrs: {
      "network": "tg",
      "url": "http://megafontravel.afisha.ru"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Share tg')
      }
    }
  }, [_c('TG', {
    staticClass: "icon-svg"
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e22ca41e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/footerApp.vue
// module id = 509
// module chunks = 1